.focusGrid {
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: clamp(1.5rem, 4vw, 3.5rem);
  align-items: start;
}

.focusText {
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
}

.focusBody {
  font-size: 1.08rem;
  line-height: 1.75;
  color: var(--color-text-muted);
}

.questions {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: 1.75rem;
}

.questionList {
  display: flex;
  flex-direction: column;
  gap: 0.95rem;
  margin: 0;
  padding-left: 1.1rem;
}

.questionList li {
  line-height: 1.55;
  color: var(--color-text);
}

.campusNote {
  margin-top: 1.25rem;
}

.paramNote {
  margin-top: clamp(1.5rem, 3vw, 2.25rem);
}

.dimCard {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  padding: 1.9rem;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  min-height: 12rem;
}

.dimTitle {
  font-family: var(--font-sans);
  font-size: var(--fs-h3);
  font-weight: 600;
}

.dimBody {
  color: var(--color-text-muted);
  line-height: 1.65;
}

.sdgGrid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.8rem;
}

.sourceList {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.sourceItem {
  display: grid;
  grid-template-columns: 7rem 1fr;
  gap: 1rem;
  align-items: baseline;
  padding: 0.9rem 1.1rem;
  border-radius: var(--radius-md);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
}

.sourceYear {
  font-family: var(--font-mono);
  font-size: 0.8rem;
  color: var(--color-accent);
}

@media (max-width: 860px) {
  .focusGrid {
    grid-template-columns: 1fr;
  }

  .sdgGrid {
    grid-template-columns: repeat(2, 1fr);
  }

  .sourceItem {
    grid-template-columns: 1fr;
    gap: 0.35rem;
  }
}

@media (max-width: 560px) {
  .sdgGrid {
    grid-template-columns: 1fr;
  }
}
